import React, { useEffect, useState } from "react";
import axios from "axios";
import MaintenancePage from "@/pages/MaintenancePage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * MaintenanceGate wraps public routes.
 * When backend reports maintenance.enabled === true, renders the MaintenancePage overlay.
 * Otherwise renders children as usual.
 * Admins can bypass by appending `?admin=1` query param (used for admin preview).
 *
 * IMPORTANT: This does NOT block /admin/* routes — those are handled in App.js
 * so superadmin can always log in and disable maintenance.
 */
const MaintenanceGate = ({ children }) => {
  const [state, setState] = useState(null); // null = loading; {enabled, ...} = loaded
  const isAdminBypass =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("admin") === "1";

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/maintenance`)
      .then((r) => {
        if (!cancelled) setState(r.data || { enabled: false });
      })
      .catch(() => {
        if (!cancelled) setState({ enabled: false });
      });
    // Poll every 60s so users know when maintenance ends
    const id = setInterval(() => {
      axios
        .get(`${API}/maintenance`)
        .then((r) => {
          if (!cancelled) setState(r.data || { enabled: false });
        })
        .catch(() => {});
    }, 60_000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  // While loading, render children to avoid a flash of blank page
  if (state === null) return children;

  if (state.enabled && !isAdminBypass) {
    return <MaintenancePage state={state} />;
  }

  return children;
};

export default MaintenanceGate;
